import { CommissionComponent } from './components/requests/commissions/components/commission/commission.component';
import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';


// modules
import { CountdownModule } from './components/countdown/countdown.module';
import { DirectivesModule } from './directives/directives.module';
import { AngularResizeEventModule } from 'angular-resize-event';
import { SharedRoutingModule } from './shared-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from './material.module';

// services
import { SharedService } from './services/shared.service';

// components
import { RequestWaitingForPaymentInfoComponent } from './components/requests/request-waiting-for-payment-info/request-waiting-for-payment-info.component';
import { RequestSelectDigitalCurrencyComponent } from './components/requests/request-select-digital-currency/request-select-digital-currency.component';
import { RequestSelectServiceNumberComponent } from './components/requests/request-select-service-number/request-select-service-number.component';
import { RequestMessageComponent } from './components/requests/request-sidebar-edit/components/request-message/request-message.component';
import { RequestWalletDetailModeComponent } from './components/requests/request-wallet-detail-mode/request-wallet-detail-mode.component';
import { RequestSidebarEditComponent } from './components/requests/request-sidebar-edit/components/request-sidebar-edit.component';
import { SelectCountryPhoneCodeComponent } from './components/select-country-phone-code/select-country-phone-code.component';
import { RequestConfirmationComponent } from './components/requests/request-confirmation/request-confirmation.component';
import { RequestPaymentTypeComponent } from './components/requests/request-payment-type/request-payment-type.component';
import { RequestSummaryComponent } from './components/requests/request-summary/request-summary.component';
import { RequestStatusComponent } from './components/requests/request-status/request-status.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { TableLoadingComponent } from './components/table-loading/table-loading.component';
import { InlineAlertComponent } from './components/inline-alert/inline-alert.component';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { Select2Component } from './components/select2/select2.component';
import { FileUploadLimitationDetailsComponent } from './components/file-upload-limitaion-details/file-upload-limitation-details.component';
import { EmptyTemplateComponent } from './components/empty-template/empty-template.component';
import { RequestStepHintComponent } from './components/requests/request-step-hint/request-step-hint.component';


// pipes
import { EnumToArrayPipe } from './pipes/EnumToArrayPipe';
import { CardNumberPipe } from './pipes/card-number.pipe';
import { EnumKeyPipe, RequestStatusTextCryptoPipe, TcCurrencyPipe, TruncateMiddlePipe } from './pipes';
import { LazyLoaderService } from './lazy/lazy-loader.service';
import { LAZY_WIDGETS } from './lazy/tokens';
import { lazyArrayToObj } from './lazy/lazy-widgets';
import {
	PaymentTypeTextPipe, RequestStatusTextPipe, PaymentStatusTextPipe, TransactionTypePipe,
	AccountTypeTextPipe, SendByTypePipe, ChangeTypeTextPipe, OnlinePaymentStatusTextPipe,
	ArchivedTypeTextPipe,
	TicketStatusTypeTextPipe
} from './types';
import { SelectThirdPartyWalletListComponent } from './components/requests/select-third-party-wallet-list/select-third-party-wallet-list.component';
import { RequestChooseDepositSecurityComponent } from './components/requests/request-choose-deposit-security/request-choose-deposit-security.component';
import { SelectThirdPartyWalletDetailComponent } from './components/requests/select-third-party-wallet-detail/select-third-party-wallet-detail.component';
import { RequestSelectServiceNumberDetailComponent } from './components/requests/request-select-service-number-detail/request-select-service-number-detail.component';
import { BreadCrumbComponent } from './components/bread-crumb/bread-crumb.component';
import { PointChangeTypeTextPipe } from './types/point-change-type';
import { SelectInputLoadingComponent } from './components/select-input-loading/select-input-loading.component';
import { RequestAmountRangeAlertComponent } from './components/requests/request-amount-range-alert/request-amount-range-alert.component';
import { CommissionExchangeFirstComponent } from './components/requests/commissions/components/commission-exchange-first/commission-exchange-first.component';
import { CommissionExchangeLastComponent } from './components/requests/commissions/components/commission-exchange-last/commission-exchange-last.component';
import { InvoiceExchangeFirstComponent } from './components/requests/commissions/components/invoice-exchange-first/invoice-exchange-first.component';
import { InvoiceExchangeLastComponent } from './components/requests/commissions/components/invoice-exchange-last/invoice-exchange-last.component';
import { CountupWithAnimationComponent } from './components/countup-with-animation/countup-with-animation.component';

import { ArraySortPipe } from './pipes/sort.pipe';
import { RemainingTimeComponent } from './components/remaining-time/remaining-time.component';
import { CheckPatternPasswordComponent } from './components/check-pattern-password/check-pattern-password.component';
import { TcDatePipe } from './pipes/tc-date.pipe';
import { SecurityLevelComponent } from './components/security-level/security-level.component';
import { VideoGuideComponent } from './components/video-guide/video-guide.component';
import { SelectCurrencyInInputComponent } from './components/select-currency-in-input/select-currency-in-input.component';
import { BalanceUnderInputComponent } from './components/balance-under-input/balance-under-input.component';
import { AlertBoxComponent } from './components/alert-box/alert-box.component';
import { FillFormFirstComponent } from './components/fiil-form-first/fill-form-first.component';
import { RequestSecurityDialogComponent } from './components/requests/request-confirmation/dialog/request-security-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AccountStatusTextPipe } from '@app/views/pages/my-accounts/types';
import { CardNumberStarsPipe } from './pipes/card-number-stars.pipe';
import { SelectWalletComponent } from './components/select-wallet/select-wallet.component';
import { RequestWalletComponent } from './components/requests/request-wallet/request-wallet.component';
import { GatewayActionTypeTextPipe } from '@app/views/pages/payment-gateway/types';
import { GatewayRequestStatusTextPipe } from '@app/views/pages/payment-gateway/types/gateway-request-status';
import { HelpDeskComponent } from './components/help-desk/help-desk.component';
import { TooltipDirective } from './directives/tooltip.directive';

@NgModule({
	declarations: [
		
	],
	imports: [
		TransactionTypePipe,
		CardNumberPipe,
		CommonModule,
		SharedRoutingModule,
		TranslateModule.forChild(),
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		CountdownModule,
		AngularResizeEventModule,
		DirectivesModule,
		VideoGuideComponent,
		HelpDeskComponent,
		BreadCrumbComponent,
		TcCurrencyPipe,
		EnumToArrayPipe,
		RequestStatusTextPipe,
		RequestStepHintComponent,
		RequestWalletComponent,
		RequestStatusComponent,
		RequestConfirmationComponent,
		TableLoadingComponent,
		EmptyTemplateComponent,
		InlineAlertComponent,
		GatewayRequestStatusTextPipe,
		GatewayActionTypeTextPipe,
		TruncateMiddlePipe,
		TooltipDirective,
		AlertBoxComponent,
		BalanceUnderInputComponent,
		RequestSidebarEditComponent,
		StarRatingComponent,
		AccountStatusTextPipe,
		PaymentStatusTextPipe,
		RequestAmountRangeAlertComponent,
		RequestSummaryComponent,
		InvoiceExchangeFirstComponent,
		CheckPatternPasswordComponent,
		ConfirmDialogComponent,
		CountupWithAnimationComponent,
		FillFormFirstComponent,
		FileUploadLimitationDetailsComponent,
		RemainingTimeComponent,
		SecurityLevelComponent,
		SelectCountryPhoneCodeComponent,
		SelectCurrencyInInputComponent,
		SelectInputLoadingComponent,
		SelectWalletComponent,
		Select2Component,
		CardNumberStarsPipe,
		EnumKeyPipe,
		ArraySortPipe,
		TcDatePipe,
		SelectThirdPartyWalletListComponent,
		SelectThirdPartyWalletDetailComponent,
		RequestWalletDetailModeComponent,
		RequestWaitingForPaymentInfoComponent,
		RequestSelectServiceNumberDetailComponent,
		RequestSelectServiceNumberComponent,
		RequestSelectDigitalCurrencyComponent,
		RequestPaymentTypeComponent,
		RequestSecurityDialogComponent,
		RequestChooseDepositSecurityComponent,
		InvoiceExchangeLastComponent,
		CommissionExchangeLastComponent,
		CommissionExchangeFirstComponent,
		CommissionComponent,
		// pipes
		PaymentTypeTextPipe,
		ChangeTypeTextPipe,
		AccountTypeTextPipe,
		SendByTypePipe,
		TicketStatusTypeTextPipe,
		ArchivedTypeTextPipe,
		OnlinePaymentStatusTextPipe,
		PointChangeTypeTextPipe,
	],
	providers: [SharedService, LazyLoaderService, { provide: LAZY_WIDGETS, useFactory: lazyArrayToObj }, CurrencyPipe],
	exports: [
		// module
		MaterialModule,
		TranslateModule,
		DirectivesModule,
		// components
		SelectCountryPhoneCodeComponent,
		RemainingTimeComponent,
		InlineAlertComponent,
		StarRatingComponent,
		TableLoadingComponent,
		RequestSummaryComponent,
		RequestPaymentTypeComponent,
		SelectInputLoadingComponent,
		RequestConfirmationComponent,
		RequestStatusComponent,
		FileUploadLimitationDetailsComponent,
		EmptyTemplateComponent,
		// RequestMessageComponent,
		RequestWalletDetailModeComponent,
		RequestSelectServiceNumberComponent,
		RequestSidebarEditComponent,
		RequestWaitingForPaymentInfoComponent,
		RequestSelectDigitalCurrencyComponent,
		RequestAmountRangeAlertComponent,
		CountupWithAnimationComponent,
		Select2Component,
		SelectThirdPartyWalletListComponent,
		RequestChooseDepositSecurityComponent,
		SelectThirdPartyWalletDetailComponent,
		CommissionExchangeFirstComponent,
		CommissionExchangeLastComponent,
		RequestSelectServiceNumberDetailComponent,
		InvoiceExchangeFirstComponent,
		InvoiceExchangeLastComponent,
		RequestStepHintComponent,
		CommissionComponent,
		SecurityLevelComponent,
		VideoGuideComponent,
		SelectCurrencyInInputComponent,
		BalanceUnderInputComponent,
		AlertBoxComponent,
		FillFormFirstComponent,
		RequestSecurityDialogComponent,
		SelectWalletComponent,
		RequestWalletComponent,
		// pipes
		PaymentTypeTextPipe,
		RequestStatusTextPipe,
		PaymentStatusTextPipe,
		OnlinePaymentStatusTextPipe,
		EnumToArrayPipe,
		TcCurrencyPipe,
		TruncateMiddlePipe,
		EnumKeyPipe,
		TransactionTypePipe,
		ArraySortPipe,
		CardNumberPipe,
		ArchivedTypeTextPipe,
		ChangeTypeTextPipe,
		AccountTypeTextPipe,
		TicketStatusTypeTextPipe,
		SendByTypePipe,
		PointChangeTypeTextPipe,
		CheckPatternPasswordComponent,
		TcDatePipe,
		AccountStatusTextPipe,
		CardNumberStarsPipe,
		GatewayActionTypeTextPipe,
		GatewayRequestStatusTextPipe,
		TooltipDirective,
	]
})
export class SharedModule { }
